<template>
  <md-dialog
      :md-active.sync="isOpen"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
      :md-fullscreen="false"
  >
    <md-dialog-title>クレジットカード本人認証手続き - 3DS2.0</md-dialog-title>
    <md-content>
      <div class="content">
        <div v-if="hasAgreedToCardAuth">
          <iframe
              v-if="creditCard3dsUrl"
              class="iframe"
              :src="creditCard3dsUrl"
          />
        </div>
        <div v-else class="consent">
          <h2>個人情報取扱いに関する同意</h2>
          <p>
            当社がお客様から収集した以下の個人情報等は、カード発行会社が行う不正利用検知・防止のために、お客様が利用されているカード発行会社へ提供させていただきます。</p>
          <p>通信情報、支払情報、取引情報、メールアドレス、住所、郵便番号、電話番号、法人名、氏名　等</p>
          <p>
            お客様が利用されているカード発行会社が外国にある場合、これらの情報は当該発行会社が所属する国に移転される場合があります。</p>
          <p>
            当社では、お客様から収集した情報からは、ご利用のカード発行会社及び当該会社が所在する国を特定することができないため、以下の個人情報保護措置に関する情報を把握して、ご提供することはできません。</p>
          <p>・提供先が所在する外国の名称</p>
          <p>・当該国の個人情報保護制度に関する情報</p>
          <p>・発行会社の個人情報保護の措置</p>
          <p>なお、個人情報保護委員会のホームページ（<a href="https://www.ppc.go.jp/"
                                                      target="_blank">https://www.ppc.go.jp/</a>）では、各国における個人情報保護制度に関する情報について掲載されています。
          </p>
          <p>お客様が未成年の場合、親権者または後見人の承諾を得た上で、本サービスを利用するものとします。</p>
        </div>
      </div>
    </md-content>
    <md-dialog-actions>
      <md-button v-if="hasAgreedToCardAuth" class="md-raised" @click="closeDialog">
        手続きを中断する
      </md-button>
      <div v-else class="button-group">
        <md-button class="md-raised" @click="closeDialog">
          同意しない
        </md-button>
        <md-button class="md-primary md-raised" @click="hasAgreedToCardAuth = true">
          同意する
        </md-button>
      </div>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name   : 'CreditCard3dsModal',
  props  : {
    isOpen          : Boolean,
    creditCard3dsUrl: {
      type    : String,
      required: false,
      default : null,
    },
  },
  data   : () => ({
    // 個人情報の取り扱いに同意したかどうか
    hasAgreedToCardAuth: false,
  }),
  methods: {
    closeDialog() {
      this.$emit('close');
      this.$emit("update:isOpen", false);
    }
  }
};
</script>

<style scoped>
.content {
  overflow: auto;
  width: 100%;
  height: 100%;
}

.iframe {
  min-width: 600px;
  height: calc(100vh - 200px);
  border: none;
}

.consent {
  overflow-y: auto;
  width: 600px;
  height: calc(100vh - 200px);
  padding: 0 16px;
}

.button-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
